<template>
    <div class="panel panel-info" >
        <!-- Default panel contents -->
        <div class="panel-heading">
            <i class="fa fa-info-circle" aria-hidden="true"></i> CAIXAS CTO NESTA FIBRA
        </div>
        <div class="panel-body">

            <table id="mytable" class="table table-bordred table-striped">

                <thead>
                    <tr>
                        <th>NOME</th>
                        <th style="text-align: center;width: 140px">CTO</th>
                        <th style="text-align: center;width: 100px">AÇÕES</th>
                    </tr>
                </thead>

                <tbody>

                    <tr v-for="r in ctos" v-bind:key="r._id">
                        <td>{{ r.nome }}</td>
                        <td class="text-center">CTO-{{ r.numero }}</td>
                        <td style="text-align: center">
                            <a :href="'#/caixa-cto/add/' + r._id" class="btn btn-primary btn-xs">
                                ABRIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                            </a>
                        </td>
                    </tr>

                </tbody>

            </table>

        </div>
    </div>
</template>

<script>
import { CaixaCTO } from "../../class/index";
export default {
    name: "ListCtoByFibra",
    props: {
        _id: {
            default: null
        }
    },
    data() {
        return {
            ctos: []
        };
    },
    beforeMount() {
        CaixaCTO.byFibra(this._id)
            .then(rows => (this.ctos = rows))
            .catch(err => console.log(err));
    }
};
</script>

<style scoped>
</style>
